import { createStore } from 'redux';
import { persistStore } from 'redux-persist';
import rootReducer from '../store/reducer'; // Adjust the path as necessary

const store = createStore(rootReducer);
const persistor = persistStore(store);

export { store, persistor };
